/** SSE contract with assistant-service — mirrors `app/sse.py` there (source of truth). */

/** Event `type` values on the wire. Unknown types are ignored, so adding one is safe. */
export enum AssistantEventType {
  TOKEN = 'token',
  ACTION = 'action',
  ERROR = 'error',
  DONE = 'done',
}

export enum ToolStatus {
  STARTED = 'started',
  COMPLETED = 'completed',
}

/** A piece of the answer, as the model generates it. Concatenate in order. */
export interface TokenEvent {
  type: AssistantEventType.TOKEN;
  text: string;
}

/** A tool started or finished. Name only — tool results never go on the wire. */
export interface ActionEvent {
  type: AssistantEventType.ACTION;
  tool: string;
  status: ToolStatus;
}

/** The turn failed after the stream opened (the HTTP status is already 200). */
export interface ErrorEvent {
  type: AssistantEventType.ERROR;
  message: string;
}

/** Last event of a successful turn. */
export interface DoneEvent {
  type: AssistantEventType.DONE;
  conversationId: string;
}

export type AssistantEvent = TokenEvent | ActionEvent | ErrorEvent | DoneEvent;

/** Tool progress accumulated for one assistant turn, in the order tools ran. */
export interface ToolRun {
  tool: string;
  done: boolean;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  /** What the rep typed (the wire text also names the participant). */
  text: string;
  /** Awaiting the first token; renders as typing dots. */
  pending?: boolean;
  /** Rendered as a plain error bubble. */
  error?: boolean;
  tools?: ToolRun[];
}
